import styles from './index.scss'
import classnames from 'classnames'

type PropsType = {
  children: any
  className?: any
  style?: React.CSSProperties
  onClick?: Function | undefined
  type?: string
  bgType?: string
  textType?: string
  disabled?: boolean | undefined
}

const DpButton = (props: PropsType) => {
  const { children, type, bgType, textType,...resProps } = props
  return (
    <button
      {...resProps} 
      className={classnames({
        [styles['dp-button-theme']]: true,
        [styles['dp-button-theme--disabled']]: !!resProps?.disabled,
        [styles[`dp-button-theme--${type}`]]: type,
        [styles[`dp-button-theme--bg-${bgType}`]]: bgType,
        [styles[`dp-button-theme--text-${textType}`]]: textType,
      }, props?.className)}
      style={resProps?.style}
    > {children}</button>
  )
}

export default DpButton
